import { Injectable } from '@angular/core';
import { SavedOffersFilter } from './saved-offers-filter';

@Injectable({
  providedIn: 'root',
})
export class SavedOffersFilterService {
  filter: SavedOffersFilter;
}
